/* unplugin-vue-components disabled */import script from "./OrdersView.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdersView.vue?vue&type=script&setup=true&lang=js"

import "./OrdersView.vue?vue&type=style&index=0&id=61515b3c&lang=scss"

const __exports__ = script;

export default __exports__